<script setup>
import { computed } from 'vue';
import isMobile from 'is-mobile';
import Mobile from './m/index.vue';
import Pc from './pc/index.vue';

const currentComponent = computed(() => {
  return isMobile() ? Mobile : Pc;
});
</script>

<template>
  <component :is="currentComponent" />
</template>
